


































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';
import { Group } from '@/store/types';
import GroupDeleteButton from '@/views/super-admin/GroupDeleteButton.vue';
import soilApiService from '../../services/soilApiService';

export default defineComponent({
	components: { GroupDeleteButton },
	props: {
		isLoading: {
			type: Boolean,
		},
		isLoaded: {
			type: Boolean,
		},
		hasError: {
			type: Boolean,
		},
		groups: {
			type: Array as () => Group[],
			default: [],
		},
	},
	setup(props, { root }) {
		const search = ref<string>('');
		const page = ref<number>(1);
		const headers: DataTableHeader[] = [
			{ text: 'ID', value: 'id' },
			{ text: 'Group Name', value: 'name' },
			{ text: 'Path', value: 'path' },
			{ text: 'Hidden', value: 'apiOnly' },
			{ text: 'Subgroups', value: 'children.length' },
			{ text: 'Created', value: 'meta.submittedAt' },
			{ text: '', value: 'actions', sortable: false },
		];

		type TableGroup = Group & { hideChangeIsLoading: boolean };

		const tableData = computed<TableGroup[]>(() =>
			props.groups.map((group) => ({
				...group,
				hideChangeIsLoading: false,
			}))
		);

		watch(search, () => (page.value = 1));

		const handleHiddenChange = (item: TableGroup, event: boolean) => {
			item.hideChangeIsLoading = true;
			soilApiService.editGroup({ groupId: item.id, apiOnly: event }).then(() => {
				root.$store.dispatch('groups/getGroups');
			});
		};

		return {
			search,
			page,
			headers,
			tableData,
			handleHiddenChange,
		};
	},
});
